import { BadgeVariant } from '@components/badge';

export const getStatusCodeBadgeVariant = (statusCode: number | null): BadgeVariant => {
  if (statusCode === null) {
    return 'neutral';
  }
  if (statusCode >= 200 && statusCode < 300) {
    return 'green';
  }
  if (statusCode >= 300 && statusCode < 400) {
    return 'orange';
  }
  if (statusCode >= 400 && statusCode < 600) {
    return 'red';
  }
  return 'neutral';
};
